import { connect } from 'react-redux';
import { compose } from 'redux';

import { relativeContextItemsByHitSetKey as relativeContextItemsByHitSetKeySelector } from '@Containers/RelativeContext/RelativeContextSelectors';
import { recordCountOrTotalResult as recordCountOrTotalResultSelector } from '@Containers/PatentFamilyClustering/selectors';

import withSortingProperties from '@Containers/SortingProperties/HOCs/withSortingProperties';
import withActiveBreadcrumb from '@Pages/Results/HOCs/withActiveBreadcrumb';
import checkResultsStateParams from '@Pages/Results/HOCs/checkResultsStateParams';
import { withToggleConditionsGlobalProvider } from '@Pages/Results/ToggleConditionsGlobalHOCs';
import { withCombinedRouteParamsforResults } from '@AppRoutes/ConnectedRoute';

import {
  resultsItems as resultsItemsSelector,
  resultsFinished as resultsFinishedSelector,
  resultsPerPage as resultsPerPageSelector,
  paginationVisible as paginationVisibleSelector,
  checkedItems as checkedItemsSelector,
  isLimitDisabled as isLimitDisabledSelector,
  breadcrumbCheckedItemsNumber as breadcrumbCheckedItemsNumberSelector,

  // Selection
  isAllResultsChecked as isAllResultsCheckedSelector,
  isAllResultsCheckedPartial as isAllResultsCheckedPartialSelector,
  checkedItemsNumber as checkedItemsNumberSelector,
} from './selectors';
import {
  initResultsStateForParams as initResultsStateForParamsAction,
  cleanResultsState as cleanResultsStateAction,
  getRelativeContexts as getRelativeContextsAction,
  checkReopenExport as checkReopenExportAction,
  fetchResultsItems as fetchResultsItemsAction,
  updateResultsPerPage as updateResultsPerPageAction,
  selectDatabase as selectDatabaseAction,
  goToResultPage as goToResultPageAction,
  showAllPreparations as showAllPreparationsAction,
  updateCheckedItemsInBreadcrumb as updateCheckedItemsInBreadcrumbAction,
  limitTo as limitToAction,
  openExportDialog as openExportDialogAction,

  // Selection
  setAllResultsChecked as setAllResultsCheckedAction,
  setAllResultsUnchecked as setAllResultsUncheckedAction,
} from './actions';
import ResultsContainer from './ResultsContainerBase';

export const mapStateToProps = (state, { params }) => {
  const relativeContexts = relativeContextItemsByHitSetKeySelector(state, params);
  return {
    relativeContexts,
    recordCountOrTotalResult: recordCountOrTotalResultSelector(state),
    resultsItems: resultsItemsSelector(state),
    resultsFinished: resultsFinishedSelector(state),
    resultsPerPage: resultsPerPageSelector(state),
    paginationVisible: paginationVisibleSelector(state),
    isLimitDisabled: isLimitDisabledSelector(state),
    isExportEnabled: true,

    // Selection
    checkedItems: checkedItemsSelector(state),
    isAllResultsChecked: isAllResultsCheckedSelector(state),
    isAllResultsCheckedPartial: isAllResultsCheckedPartialSelector(state),
    breadcrumbCheckedItemsNumber: breadcrumbCheckedItemsNumberSelector(state, params),
    checkedItemsNumber: checkedItemsNumberSelector(state),
  };
};

const mapDispatchToProps = {
  getRelativeContexts: getRelativeContextsAction,
  checkReopenExport: checkReopenExportAction,
  initResultsStateForParams: initResultsStateForParamsAction,
  cleanResultsState: cleanResultsStateAction,
  fetchResultsItems: fetchResultsItemsAction,
  updateResultsPerPage: updateResultsPerPageAction,
  selectDatabase: selectDatabaseAction,
  goToResultPage: goToResultPageAction,
  showAllPreparations: showAllPreparationsAction,
  updateCheckedItemsInBreadcrumb: updateCheckedItemsInBreadcrumbAction,
  limitTo: limitToAction,
  openExportDialog: openExportDialogAction,

  // Selection
  setAllResultsChecked: setAllResultsCheckedAction,
  setAllResultsUnchecked: setAllResultsUncheckedAction,
};

export default compose(
  withCombinedRouteParamsforResults,
  connect(mapStateToProps, mapDispatchToProps),
  withActiveBreadcrumb(),
  withSortingProperties(),
  checkResultsStateParams(),
  withToggleConditionsGlobalProvider()
)(ResultsContainer);
